<!-- Backdrop overlay -->
@if (isOpen()) {
  <div
    class="fixed inset-0 z-40"
    (click)="closeDropdown()"
    (keydown.escape)="closeDropdown()"
    role="button"
    tabindex="-1"
    aria-label="Close dropdown"
  ></div>
}

<div class="relative">
  <!-- Dropdown trigger button -->
  <button
    type="button"
    (click)="toggleDropdown()"
    class="flex items-center gap-1.5 text-background-contrast transition-opacity hover:opacity-80 focus:outline-none cursor-pointer"
    aria-label="Select language"
    [attr.aria-expanded]="isOpen()"
  >
    <img [src]="currentLanguage().flag" alt="" class="size-6 rounded-full object-cover" />
    <span class="text-sm font-medium leading-5">{{ currentLanguage().code.toUpperCase() }}</span>
    <img
      src="/icons/chevron-down-white.icon.svg"
      alt=""
      class="size-[1.125rem] transition-transform"
      [class.rotate-180]="isOpen()"
    />
  </button>

  <!-- Dropdown menu -->
  @if (isOpen()) {
    <div
      class="absolute right-0 z-50 mt-2 min-w-32 rounded-lg bg-white p-2 shadow-lg"
      role="menu"
      aria-orientation="vertical"
    >
      @for (language of languages; track language.code) {
        <button
          type="button"
          (click)="selectLanguage(language.code)"
          class="flex w-full items-center gap-1.5 rounded-lg px-2.5 py-2.5 text-left transition-colors hover:bg-gray-50 focus:outline-none cursor-pointer"
        >
          <img [src]="language.flag" alt="" class="h-[0.75rem] w-[1rem] rounded-sm object-cover" />
          <span
            class="flex-1 text-sm font-medium leading-4"
            [class.text-text-primary]="language.code === currentLanguage().code"
            [class.text-text-secondary-alpha]="language.code !== currentLanguage().code"
          >
            {{ language.code.toUpperCase() }}
          </span>
          <!-- Radio button -->
          <div
            class="flex size-3.5 items-center justify-center rounded-full border border-gray-300"
          >
            @if (language.code === currentLanguage().code) {
              <div class="size-2 rounded-full bg-primary"></div>
            }
          </div>
        </button>
      }
    </div>
  }
</div>
